<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.mobileDevices") }}</h3>
            </div>
            <div class="card-body">
                <table class="table table-striped table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("gatehouse.label") }}</th>
                            <th>{{ $t("device.id") }}</th>
                            <th>{{ $t("device.deviceName") }}</th>
                            <th>{{ $t("device.lastSeen") }}</th>
                            <th>{{ $t("device.batteryStatus") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="mobileDevices.length">
                        <tr
                            v-for="mobile in paginatedDevices"
                            :key="mobile.id"
                            class="align-middle"
                        >
                            <td>{{ mobile.gatehouse_name }}</td>
                            <td>{{ mobile.device_id }}</td>
                            <td>{{ mobile.device_name }}</td>
                            <td>
                                {{ mobile.last_seen ? $d(new Date(mobile.last_seen), 'long') : "--" }}
                            </td>
                            <td>
                                <div class="d-flex align-items-center justify-content-center">
                                    <icon
                                        :icon="mobile.is_charging ? 'BatteryCharging' : 'Battery'"
                                        class="me-1"
                                    />
                                    <span>{{ mobile.battery_level }}%</span>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <button
                                        class="btn btn-primary btn-sm me-2"
                                        @click.stop="goToDetail(mobile)"
                                    >
                                        <icon icon="Search"></icon>
                                    </button>
                                    <button
                                        class="btn btn-warning btn-sm me-2"
                                        @click="toggleDevice(mobile.id)"
                                        :title="mobile.is_active ? $t('device.deactivate') : $t('device.activate')"
                                    >
                                        <icon :icon="mobile.is_active ? 'Lock' : 'LockOpen'"></icon>
                                    </button>
                                    <button
                                        class="btn btn-danger btn-sm"
                                        @click="deleteDevice(mobile)"
                                    >
                                        <icon icon="Trash"></icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6" class="text-center text-muted py-3">
                                {{ $t("device.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="mobileDevices.length >= 5" class="d-flex justify-content-between mx-4">
                    <Paginate
                        :page-count="totalPages"
                        :click-handler="(p) => currentPage = p"
                        :prev-text="'«'"
                        :next-text="'»'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :active-class="'active'"
                        :disabled-class="'disabled'"
                    />
                    <div class="flex-shrink-0">
                        <select v-model="perPage" class="form-select form-select-sm" style="height: 40px;">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="25">20</option>
                            <option :value="50">50</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import Paginate from 'vuejs-paginate-next';

export default {
    components: {
        Icon,
        Paginate,
    },
    data() {
        return {
            mobileDevices: [],
            currentPage: 1,
            perPage: 10,
        }
    },
    computed: {
        paginatedDevices() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.mobileDevices.slice(start, start + this.perPage);
        },
        totalPages() {
            return Math.ceil(this.mobileDevices.length / this.perPage);
        }
    },
    created() {
        this.getMobileDevices();
    },
    methods: {
        getMobileDevices() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/mobile-devices`)
            .then(response => {
                this.mobileDevices = response.data;
            })
            .catch(error => {
                console.error("Error loading mobile devices. ", error)
            });
        },
        goToDetail(mobile) {
            this.$router.push({
                name: "MobileDeviceDetailView",
                params: {
                    slug: this.$route.params.slug,
                    id: mobile.id,
                }
            })
        },
        deleteDevice(mobile) {
            const confirm = window.confirm(this.$t("utils.deleteConfirm", { name: mobile.device_name }));
            if (!confirm) return;

            this.$store.getters.api.delete(`/dashboard/${this.$route.params.slug}/mobile-devices/${mobile.id}/delete`)
            .then(() => {
                this.getMobileDevices();
            })
            .catch(error => {
                console.error("Error deleting mobile device.", error);
            });
        },
        toggleDevice(deviceId) {
            this.$store.getters.api.patch(`/dashboard/${this.$route.params.slug}/mobile-devices/${deviceId}/toggle-active`)
            .then(() => {
                this.getMobileDevices();
            })
            .catch(error => {
                console.error("Error toggling device.", error);
            });
        },
    }
}
</script>